import { idParam, ROLES } from "../../../../../helpers/commons.helpers";

/**
 * Experiences route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object with common
 * properties used by navigation guards and permission checks.
 *
 * @typedef {Object} ExperienceRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - When true the route requires an authenticated session.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/experiences/rhomtrip",
        name: "Experiences",
        meta: {
            title: "Experiences",
            modules: ["experiences"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
                /* webpackChunkName: "experiences" */ "@/modules/experiences/modules/rhomtrip/pages/Experiences"
            )
    },
    {
        path: "/experiences/rhomtrip/new",
        name: "NewExperience",
        meta: {
            title: "New Experience",
            modules: ["experiences"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
                /* webpackChunkName: "experiences" */ "@/modules/experiences/modules/rhomtrip/pages/NewExperience"
            )
    },
    {
        path: `/experiences/rhomtrip/${idParam()}`,
        name: "ExperienceDetails",
        meta: {
            title: "Experience Details",
            modules: ["experiences"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
                /* webpackChunkName: "experiences" */ "@/modules/experiences/modules/rhomtrip/pages/Experience"
            )
    },
    {
        path: `/experiences/rhomtrip/web-preview/:id`,
        name: "PreviewExperience",
        meta: {
            title: "Preview Experience",
            modules: ["experiences"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
                /* webpackChunkName: "experiences" */ "@/modules/experiences/modules/rhomtrip/pages/PreviewExperience"
            )
    }
]